import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadablePackageManager = Loadable({
  loader: function loader() {
    return import('../PackageManager.jsx');
  },
  loading: ComponentLoading
});
export default LoadablePackageManager;